import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { saveAuditHistory } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const saveRiskAuditHistory = createApi(
  saveAuditHistory,
  "POST"
);

const userDefinedRiskStatusSlice = createSlice({
  name: "userDefinedRiskStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveRiskAuditHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveRiskAuditHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(saveRiskAuditHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userDefinedRiskStatusSlice.reducer;
